import PatchWorker from './PatchWorker';

const STRING = 'string';

class GameDataPatch {
    constructor (base) {
        if (typeof base === STRING) {
            this.data = JSON.parse(base);
        } else {
            this.data = base;
        }
        this.patchWorker = new PatchWorker(this);
    }

    /**
     * Apply a set of text diffs (patches) and verify the result is parsable
     * If the patch process fails, success will be false and data will be the unpatched
     * object.
     * @param  {mixed} diffs Diff or array of diffs to be applied to the current
     *                       data set
     * @return {object}      Response object containing a success flag and the patched data
     */
    patch (diffs) {
        let patched = null;
        try {
            patched = this.patchWorker.patch(diffs);
        } catch (err) {
            console && console.error('patch worker error', err);
        }
        return this.verifyPatch(patched);
    };

    /**
     * @NOTE  not functional after switch to json-patch... need to ues an alternate lib for this
     * Create a diff string against the previous set of data.
     *
     * @param  {mixed} newData  JSON object or string of new data to diff against the previous
     *                          data set
     * @return {object}         Response object containing a diff key/val
     */
    diff (newData) {
        return newData;
        const newDataString = (typeof newData === STRING) ? newData : JSON.stringify(newData);

        return this.patchWorker.diff(newDataString);
    }

    /**
     * Verify that a patch procedure mostly succeded and the resulting
     * string can be parse back to json.
     * @todo Might need to make this verification a little tigher somehow.
     *       Unfortunately, the errors output
     * @param  {object}  patched Resulting json object from a patch operation.
     * @return {object}         Response object containg the data and a success flag
     */
    verifyPatch (patched) {
        let success = true;

        if (patched) {
            success = true;
            this.data = patched;
        } else {
            success = false;
        }

        return {
            success,
            data: this.data
        };
    }

    destroy () {
        this.patchWorker?.destroy();
        this.data = null;
        this.patchWorker = null;
    }
}

export default GameDataPatch;
